// Lightweight notification "ding" using the Web Audio API (no asset / network needed).
// Browsers block audio until the user interacts with the page, so we create/resume the
// AudioContext inside the first user gesture (unlockAudio) and then poll-triggered plays work.
let ctx = null;

function getCtx() {
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctx) ctx = new AC();
  return ctx;
}

// Call this from a user-gesture handler (click/keydown/touch) to unlock audio playback.
export function unlockAudio() {
  const c = getCtx();
  if (!c) return;
  if (c.state === "suspended") c.resume().catch(() => {});
  try {
    // A 1-sample silent buffer fully unlocks audio on iOS/Safari.
    const buf = c.createBuffer(1, 1, 22050);
    const src = c.createBufferSource();
    src.buffer = buf;
    src.connect(c.destination);
    src.start(0);
  } catch {
    // audio unlock not supported; ignore
  }
}

export function playNotificationSound() {
  try {
    const c = getCtx();
    if (!c) return;
    if (c.state === "suspended") c.resume().catch(() => {});
    const now = c.currentTime;
    const notes = [880, 1174.66]; // A5 -> D6, a soft two-note chime
    notes.forEach((freq, i) => {
      const osc = c.createOscillator();
      const gain = c.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      const start = now + i * 0.12;
      gain.gain.setValueAtTime(0, start);
      gain.gain.linearRampToValueAtTime(0.2, start + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.26);
      osc.connect(gain);
      gain.connect(c.destination);
      osc.start(start);
      osc.stop(start + 0.3);
    });
  } catch {
    // audio unavailable; ignore
  }
}
